import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import * as Sentry from "@sentry/react";
import App from "./App";

import "./scss/custom_bootstrap.scss";
import "./request-invoice.css";
import "./index.css";

import * as serviceWorker from "./serviceWorker";
import { initSentry } from "./sentry";

// Initialize Sentry before rendering the app
initSentry();

// React 19 error hooks for comprehensive error capture
const root = createRoot(document.getElementById("root"), {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
